module.exports = __webpack_public_path__ + "media/images/ui__arrowLeft--dark-ac9d6e5787bdcf49ae44cd8db6a63ab5.png";